import React from "react";
import errorImage from "../image/Error-page.png";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { t } from "i18next";

function NotFound() {
  return (
    <Container
      maxWidth="xl"
      sx={{ height: "100vh" }}
      title={t("common.notFound", { ns: ["home"] })}
    >
      <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
        <Box>
          <Grid
            container
            spacing={1}
            alignItems="center"
            justifyContent="center"
            style={{ height: "50vh" }}
          >
            <Grid item xs={8}>
              <Box>
                <Typography variant="h4">{t("common.wentWrong", { ns: ["home"] })}</Typography>
                <p>
                  <br />
                  {t("common.notFoundPageText", { ns: ["home"] })}
                  <br />
                  <br />
                </p>
                <Box>
                  <Button variant="contained" href="/signin">
                    {t("common.backHome", { ns: ["home"] })}
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box>
          <Box mt={10}>
            <img
              width="520vh"
              height="500vh"
              style={{
                objectFit: "cover",
                objectPosition: "center",
              }}
              src={errorImage}
              alt=""
            />
          </Box>
        </Box>
      </Grid>
    </Container>
  );
}

export default NotFound;
